export default __webpack_public_path__ + "static/media/safari1.2e236ab7.jpg";